"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var optimization_result_service_1 = __importDefault(require("./optimization-result-service"));
var OptimizationResultApi = /** @class */ (function () {
    function OptimizationResultApi(session) {
        this.optimizationResultService = new optimization_result_service_1.default(session);
    }
    OptimizationResultApi.prototype.load = function (teamId, requestUuid) {
        return this.optimizationResultService.load(teamId, requestUuid);
    };
    OptimizationResultApi.prototype.loadAll = function (request) {
        return this.optimizationResultService.loadAll(request);
    };
    OptimizationResultApi.prototype.rerun = function (request) {
        return this.optimizationResultService.rerun(request);
    };
    return OptimizationResultApi;
}());
exports.default = OptimizationResultApi;
//# sourceMappingURL=optimization-result-api.js.map